export default __webpack_public_path__ + "static/media/pc_background3@2x.da54f68e.png";